import { FC } from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import IconButton from '@mui/material/IconButton';

type Props = {
  sort?: 'ASC' | 'DESC' | null;
};

const TableHeadCellSort: FC<Props> = ({ sort }) => {
  if (!sort) return null;

  return (
    <IconButton size="small" sx={{ position: 'absolute', right: 0 }}>
      {sort === 'ASC' ? (
        <ArrowUpwardIcon fontSize="inherit" />
      ) : (
        <ArrowDownwardIcon fontSize="inherit" />
      )}
    </IconButton>
  );
};

export default TableHeadCellSort;
